const topicTags = [
  { label: '韩漫推荐', hot: true },
  { label: '日漫连载', hot: true },
  { label: '国漫崛起', hot: true },
  { label: '条漫精选', hot: false },
  { label: '热血战斗', hot: false },
  { label: '恋爱甜宠', hot: true },
  { label: '悬疑推理', hot: false },
  { label: '异世界', hot: true },
  { label: '免费漫画', hot: false },
  { label: '新作上架', hot: true },
  { label: '完结佳作', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            话题
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            大家都在讨论的漫画话题，看看有没有你感兴趣的
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all hover:scale-105 cursor-pointer ${
                tag.hot
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 border border-background-300/60 hover:border-accent-300 hover:text-accent-600'
              }`}
            >
              {tag.label}
              {tag.hot && (
                <span className="flex items-center">
                  <i className="ri-fire-line text-xs"></i>
                  <span className="text-xs ml-1">{['2.8w', '2.1w', '3.5w', '', '1.6w', '1.9w', '', '2.4w', '', '4.2w', ''][i]}</span>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}